<div class="tabs-wrapper">
  <rt-tabs>
    <rt-tab
      *ngFor="let tab of slackIntegrations; trackBy: trackByIntegration"
      [disabled]="actionsDisabled"
      (click)="selectSlackIntegration(tab)"
      [class.current]="slackIntegration === tab"
    >
      {{ tab.channelName }}
    </rt-tab>
    <rt-tab (click)="addChannel()">
      {{ 'app.settings.integrations.slack.add_channel' | translate }}
    </rt-tab>
  </rt-tabs>
</div>

<div *ngIf="slackIntegration" class="activity-subscriptions-wrapper">
  <rt-activity-subscriptions-follow-offer
    [types]="[ActivitySubscriptionType.Slack]"
    [activitySubscriptions]="slackIntegration.activitySubscriptions"
    [hasOverdueCandidates]="false"
    [abilities]="abilities"
    [hasRequisitions]="hasRequisitions"
    (changeEvents)="changeEvents($event)"
  ></rt-activity-subscriptions-follow-offer>
  <rt-divider variant="medium"></rt-divider>
  <rt-activity-subscriptions-followed-by-me-offer
    [types]="[ActivitySubscriptionType.Slack]"
    [activitySubscriptions]="slackIntegration.activitySubscriptions"
    [hasOverdueCandidates]="false"
    [abilities]="abilities"
    [hasRequisitions]="hasRequisitions"
    (changeEvents)="changeEvents($event)"
  ></rt-activity-subscriptions-followed-by-me-offer>
  <rt-divider variant="medium"></rt-divider>
  <rt-activity-subscriptions-company
    [types]="[ActivitySubscriptionType.Slack]"
    [activitySubscriptions]="slackIntegration.activitySubscriptions"
    [abilities]="abilities"
    [hasRequisitions]="hasRequisitions"
    (changeEvents)="changeEvents($event)"
  >
  </rt-activity-subscriptions-company>
  <div layout-horizontal margin-top>
    <rt-button
      [disabled]="actionsDisabled"
      (click)="deleteSlackIntegration(slackIntegration)"
      variant="plain"
      class="danger-on-hover"
    >
      <span>{{ 'app.settings.integrations.slack.remove' | translate }}</span>
      <rt-icon name="remove-circle"></rt-icon>
    </rt-button>
  </div>
</div>
